import { Box, Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { Fragment, type FunctionComponent } from "react";

interface Props {
    title: string;
    description: string[];
}

export const StepByStep: FunctionComponent<Props> = ({ title, description }) => {
    return (
        <Fragment>
            <VStack gap="8">
                <Typography variant="body-s-strong">{title}</Typography>
                <Box as="ul" m="0" ps="32">
                    {description.map((item) => (
                        <li key={`step-${title}-${item}`}>
                            <Typography variant="body-s" textColor="base.subtle">
                                {item}
                            </Typography>
                        </li>
                    ))}
                </Box>
            </VStack>
        </Fragment>
    );
};
